import {
  resolveDeviceSpeechLocale,
  waitForCompatibleDeviceSpeechVoice,
} from "./device-speech-fallback.mjs";
import { deviceSpeechOnlyForLanguage } from "./audio-voice-policy.mjs";

const BRIEF_JOURNEY_PATH = /^\/api\/brief\/narration\/item\/[^/]+\/generate$/;
const STANDALONE_AUDIO_PATHS = new Set([
  "/api/carousel-card-insight-audio",
  "/api/facts/audio",
  "/api/learning/audio",
  "/api/news-category-audio",
  "/api/news-story-audio",
  "/api/quote/audio",
  "/api/spark/audio",
  "/api/stock-why-audio",
]);

export function deviceSpeechPlanKindForAudioPath(path) {
  if (path === "/api/dashboard-briefing-audio") return "dashboard";
  if (BRIEF_JOURNEY_PATH.test(path)) return "brief-journey";
  return STANDALONE_AUDIO_PATHS.has(path) ? "standalone" : null;
}

export async function negotiateDeviceSpeechForAudioRequest({
  path,
  requestedVoiceId,
  languageCode,
  countryCode,
  signal,
}) {
  const kind = deviceSpeechPlanKindForAudioPath(path);
  if (!kind || requestedVoiceId !== "auto") return null;
  const locale = resolveDeviceSpeechLocale(languageCode, countryCode);
  if (!locale) return null;
  const available = await waitForCompatibleDeviceSpeechVoice(locale, { signal });
  if (available) {
    return Object.freeze({ availability: "available", kind, locale });
  }
  return deviceSpeechOnlyForLanguage(languageCode)
    ? Object.freeze({
        availability: "required-voice-unavailable",
        kind,
        locale,
      })
    : null;
}
